module.exports = __webpack_public_path__ + "static/coffee-one-on-one-coaching-667f264df58795a7950ea93104b0e77d.jpg";